import type { LinkContent } from "@prismicio/types-internal/lib/content"

import type { ImageBlockData } from "../../../../core/imageUtils"
import { LinkField } from "../../../LinkField"

type LinkTo = ImageBlockData["linkTo"]

interface ImageLinkControlProps {
  linkTo: LinkTo
  onLinkToChange: (linkTo: LinkTo) => void
}

export function ImageLinkControl(props: ImageLinkControlProps) {
  const { linkTo, onLinkToChange } = props

  return (
    <LinkField
      content={toContent(linkTo)}
      onContentChange={(content) => onLinkToChange(fromContent(content))}
      field={{
        type: "Link",
        config: {
          label: "Link",
          allowTargetBlank: true
        }
      }}
    />
  )
}

function toContent(linkTo: LinkTo): LinkContent | undefined {
  return linkTo
    ? {
        __TYPE__: "LinkContent",
        value: linkTo
      }
    : undefined
}

function fromContent(content: LinkContent | undefined): LinkTo {
  return content ? content.value : undefined
}
